import { FiFileText } from "react-icons/fi";
import Button from "../Button";

const MockTestCard = ({ title, details, attempts, onClick }) => {
  return (
    <div className="col-md-3 col-6 mb-4">
      <div className="rounded-lg border border-primary hover-card">
        <div className="p-4 text-center">
          {/* Icon */}
          <div className="mb-3">
            <FiFileText size={32} className="text-primary" />
          </div>
          {/* Title */}
          <h6 className="fw-bold text-light mb-2">{title}</h6>
          {/* Details */}
          <p className="text-light small mb-3">{details}</p>
          {/* Attempts */}
          <p className="text-accent small mb-3">{attempts} attempts taken</p>
          {/* Button */}
           <Button variant="gradient" fullWidth> Take Test</Button>
        </div>
      </div>
    </div>
  );
};

export default MockTestCard;